/**
 * @param languageTag IETF BCP 47 language tag
 * @returns ISO 639-1:2002 language (e.g `'de'`)
 */
export function getLanguage(languageTag: string): string {
  return languageTag.slice(0, 2);
}
